import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Icon from 'react-feather';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsUserSettingsModalOpen,
  setIsWhatsappModalOpen,
} from '../../../../redux/modal/modal.actions';

import LabeledToggle from '../../form/LabeledToggle';
import {
  basePatchQuery,
  handleChangePassword,
} from '../../../../utility/sb-api/sb-api.service';
import { notification } from '../../../../utility/notification/notification.service';

const UserSettingsModal = ({ isOpen, setIsUserSettingsModalOpen, me }) => {
  const intl = useIntl();
  const closeModal = () => setIsUserSettingsModalOpen(false);

  const [customerProfile, setCustomerProfile] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);
  const [
    isWhatsAppNotificationEnabled,
    setIsWhatsAppNotificationEnabled,
  ] = useState(false);

  useEffect(() => {
    if (me?.requester) {
      setCustomerProfile(me?.requester?.customerProfile);
      setIsWhatsAppNotificationEnabled(
        me?.requester?.customerProfile?.whatsAppSendNotifications,
      );
    }
  }, [me]);

  const handleToggle = (value) => {
    setSubmitting(true);
    basePatchQuery(`customer-profiles/${customerProfile.id}`, {
      ...value,
    })
      .then((customerProfile) => {
        setSubmitting(false);
        setCustomerProfile(customerProfile);
        setIsWhatsAppNotificationEnabled(
          customerProfile?.whatsAppSendNotifications,
        );
        notification('success', 'changesSaved');
      })
      .catch(() => {
        notification('error', 'changesSavedError');
      });
  };

  return (
    <>
      <ModalSheet
        isOpen={isOpen}
        closeModal={closeModal}
        title={intl.formatMessage({
          id: 'userSettingsModalTitle',
        })}
      >
        <div className="ml-1 mr-1">
          <LabeledToggle
            disabled={isSubmitting}
            checked={isWhatsAppNotificationEnabled}
            onClick={() =>
              handleToggle({
                whatsAppSendNotifications: !isWhatsAppNotificationEnabled,
              })
            }
            wrapperClassName="d-flex align-content-center justify-content-between mb-25"
            headingMessageId="enableWhatsappNotificationToggleLabel"
            subHeadingMessageId="enableWhatsappNotificationToggleText"
            headingClassName="d-block dark"
          />
        </div>
        <hr />
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={handleChangePassword}
        >
          <Icon.Lock
            data-testid="passwordChangeButton"
            size={20}
            className="primary"
          />
          <span className="ml-1 font-medium-1">
            <FormattedMessage id="passwordChageLabel" />
          </span>
        </div>
        <hr />
      </ModalSheet>
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isUserSettingsModalOpen,
  store: state.store.store,
  me: state.me.me,
  data: state.modals.listAddressesModalData,
});

export default connect(mapStateToProps, {
  setIsUserSettingsModalOpen,
  setIsWhatsappModalOpen,
})(UserSettingsModal);
